<template>
  <div>
    <div v-for="(page, index) in pageGroupedElements" :key="'page-' + index" class="position-relative dinA4">
      <img :src="require('@/assets/insular-header.png')" class="mb-0 page__header" />
      <div class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex">
          <div v-if="element.type === 'table' && element.tableType === 'balear' && !hugeBalear">
            <img class="img-contain table-section-icon" :src="require('@/assets/cttbaleares-icon.png')" />
          </div>
          <div v-if="element.type === 'table'" class="d-flex justify-center mb-4">
            <div v-if="element.tableType !== 'balear'">
              <img class="img-contain table-section-icon" :src="element.imageUrl" />
            </div>
            <PdfProductTable v-for="(id, i) in element.ids" :key="'table-' + i" :type="element.tableType"
              :tableData="productTableList[id]" :tableId="id" />
          </div>
          <div v-else :class="`d-flex justify-center mt-4 ${element.relatedTableType === 'balear' ? 'mb-6' : null}`
            ">
            <div class="d-flex flex-column">
              <p class="small-letter-font small-letter-font--bold mb-0">
                {{ element.intro }}
              </p>
              <ul class="small-letter-font justify-text">
                <li v-for="(elementList, listIndex) in element.list" :key="'elementList' + listIndex"
                  v-html="elementList" />
              </ul>
              <p v-if="element.outro" class="small-letter-font  justify-text mt-6 mb-0" v-html="element.outro" />
            </div>
          </div>
        </div>
      </div>

      <Footer v-if="!(page[0].tableType === 'balear' && hugeBalear)" logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2021/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2021/Footer'

export default {
  name: 'InsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/cttcanarias-icon.png'),
          indexes: [6, 7],
          ids: ['CAN13H', 'CAN24H'],
          tableType: 'cannary',
        },
        {
          type: 'table',
          imageUrl: require('@/assets/special-ecommerce.png'),
          indexes: [8, 9],
          ids: ['CANECOMMERCE', 'CANMARITIMO'],
          tableType: 'cannary',
        },
        {
          type: 'text',
          relatedTableType: 'cannary',
          intro: 'Características de los servicios CTT Canarias (LPA - TNF / Resto de Islas):',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas',
            '- Cubicaje: Conversión volumétrica 167kg/m3 aéreo y 333 kg/m3 marítimo',
            '- Para los envíos a Islas Menores e Inter Islas se aplicará sobre la tarifa de Islas Mayores un suplemento de reexpedición Inter Islas (consultar suplemento de reexpediciones en la pág. 9 de este documento).',
          ],
          outro:
            '(*) <u>Tarifa Especial Ecommerce</u>: Para envíos de Bajo Valor (hasta 150 €), incluye los trámites de Gestión Aduanera Simplificada (GAS). Para envíos de Alto Valor (> 150€), se aplicará un suplemento (consultar suplemento por Alto Valor en la pág. 9 de este documento). Para el resto de los servicios con origen o destino Canarias, no incluye DUA ni Gestión Aduane Simplificada (GAS).',
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttbaleares-icon.png'),
          indexes: [10, 11, 12],
          ids: ['BAL13H', 'BAL24H', 'BAL48H'],
          tableType: 'balear',
        },
        {
          type: 'text',
          relatedTableType: 'balear',
          intro: 'Características de los servicios Baleares (Mallorca / Resto de Islas):',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Los servicios Ctt e24h y Ctt e48h que dispongan de teléfono móvil, se beneficiarán GRATIS del <u>Preaviso de Entrega</u>, el servicio de <u>Entrega flexible</u> y la <u>Predicción de Franja Horaria</u>.',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/cttotherdest-icon.png'),
          indexes: [5],
          ids: ['OTHERDESTINATIONS'],
          tableType: 'otherDestinations',
        },
        {
          type: 'text',
          relatedTableType: 'otherDestinations',
          intro:
            'Características de los servicios Ceuta, Melilla Gibraltar, Andorra e Islas Portugal:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas',
            '- Cubicaje: Conversión volumétrica 167kg/m3 (333kg/m3 marítimo).',
          ],
        },
      ],
      hugeBalear: false,
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let doubleRow = false
      let rowElementCounter = 0

      for (let i = 0; i < this.elements.length; i++) {
        let actualElement = this.elements[i]
        if (actualElement.type !== 'text') {
          // for (let index = 0; index < actualElement.indexes.length; index++) {
          for (const id of actualElement.ids) {
            const numberOfRows = Object.keys(this.productTableList[id].kgRows).length

            if (numberOfRows > 15) {
              if (actualElement.tableType === 'balear') {
                this.hugeBalearMod(true)
              }
              singleRow = true
            } else if (numberOfRows > 7) {
              doubleRow = true
            }
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else if (doubleRow) {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter === 2 || rowElementCounter === this.elements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (
            (rowElementCounter === 2 &&
              actualElement.type === 'text' &&
              actualElement.relatedTableType === 'cannary' &&
              this.elements.filter(
                element => element.type === 'table' && element.tableType === 'cannary',
              ).length === 1) ||
            (rowElementCounter === 3 && actualElement.type !== 'table') ||
            (rowElementCounter === 4 &&
              actualElement.type === 'text' &&
              actualElement.relatedTableType !== ' balear') ||
            rowElementCounter === this.elements.length
          ) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }
      return pages
    },
  },
  methods: {
    hugeBalearMod(huge) {
      this.hugeBalear = huge
    },
  },
  created() {
    this.$emit('updateTotalPages', { InsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularTables')
  },
}
</script>
